import { useParams } from 'react-router-dom';

/**
 * Get image's depending on the provided client
 *
 * @param  {string} name image name
 * @param  {string} client client shortname
 * @return {string} image's path
 */
export const getImagePath = (name, client = 'default') => {
  return `/clients/${client}/assets/images/${name}`;
}

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

/**
 * getImagePath react hooks implementation
 *
 * @param  {string} name image name
 * @return {string} image's path
 */
export const useImage = (name) => {
  const { client } = useParams();

  return getImagePath(name, client);
}

export const replaceParamsInUrl = (url, params) => {
  Object.entries(params).forEach(entries => {
    const [key, value] = entries;
    url = url.replaceAll(`{${key}}`, value);
  })
  return url;
};

/**
 * Replace params in query string 'search'
 * @param {string} querystring - the query params.
 * @param {Object} paramsAndValues - Obejct with param and avalue {method: ''dlocal, language: 'en'...}
 * @returns {string} - new query string params.
 */
export const replaceParamsInQueryString = (querystring, paramsAndValues) => {
  const searchParams = new URLSearchParams(querystring);

  Object.entries(paramsAndValues).forEach(([param, value]) => {
    searchParams.set(param, value);
  });

  return searchParams.toString();
}

/**
 * Selects the first object in an array if the array is valid and the first item is neither null nor undefined.
 *
 * @param {Array} array - The input array to evaluate.
 * @returns {Object|Array} - The first object in the array if valid, otherwise an empty array.
 */
export const selectFirstObject = (array) => {
  if (Array.isArray(array) && array.length > 0) {
      const firstItem = array[0];
      if (firstItem !== null && firstItem !== undefined) {
          return firstItem;
      }
  }
  return [];
};

export const checkImageExists = async (imagePath, callback) => {
  const img = new Image();
  img.src = imagePath;
  img.onload = () => callback(true);
  img.onerror = () => callback(false);
};

export const pickPromoSlugFromSearchObj = (searchObj) => {
  const v = searchObj?.promoSlug;
  if (v == null || v === '') return undefined;
  return Array.isArray(v) ? v[0] : v;
};

export const shouldApplyCouponToShoppingCart = (couponApply, shoppingCart) => {
  if (!couponApply?.code) return false;
  const couponProductIds = couponApply.products || [];
  if (!couponProductIds.length) return true;

  const cartProductIds = shoppingCart?.productsToBuy?.map((product) => product.productID) || [];
  return couponProductIds.some((productId) => cartProductIds.includes(productId));
};

export const couponApplyBuilder = (coupon) => {
  return {
    ...(coupon.code && { code: coupon.code }),
    type: coupon.type,
    products: coupon.products,
    discount: coupon.discount,
    ...(!coupon.cycles && { duration: coupon.duration } ),
    cycles: coupon.cycles,
    ...(coupon?.cyclesDuration && { cyclesDuration: coupon?.cyclesDuration }),
    ...(coupon?.cyclesDuration && { foreverCycles: true })
  }
}